import Confirmation from "@/Components/Modal/Confirmation";
import useConfirm from "@/shared/atoms/useConfirm";
import useModal, { useSetModal } from "@/shared/atoms/useModal";
import { useSetPosModal } from "@/shared/atoms/usePosModal";
import useIsOrderEditingHook from "@/shared/hooks/useIsOrderEditingHook";
import "rc-slider/assets/index.css";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import PosSystem from "./PosSystem";
import { cn } from "@/shared/utils/cn";
import useOverlayAtom from "@/shared/atoms/useOverlayAtom";

export interface PosOrderSideProps {
  active: boolean;
  onExit?: () => void;
}

const PosOrderSide = ({ active, onExit }: PosOrderSideProps) => {
  const { t } = useTranslation();
  const [headerHeight, setHeaderHeight] = useState(80);
  const { isOrderEditing, setEditOrder } = useIsOrderEditingHook();
  const [showConfirmation, setConfirmation] = useState(false);
  const [{ type: hasOpenModal }] = useModal();
  const setModal = useSetModal();
  const [{ closeOnClickOutside }] = useOverlayAtom();
  const [confirmModal, setConfirmModal] = useConfirm();
  const setPosOrderSide = useSetPosModal();

  useEffect(() => {
    const header = document.querySelector("header");
    const observer = new ResizeObserver(() => {
      setHeaderHeight(header?.offsetHeight || 80);
    });
    observer.observe(header);

    return () => {
      observer?.disconnect();
      setPosOrderSide(false);
    };
  }, []);

  return (
    <div>
      {showConfirmation && (
        <Confirmation
          title={t("posOrders.orderEditing")}
          description={t("posOrders.areYouSureToQuit")}
          disableCheckbox
          onSuccess={() => {
            setEditOrder({});
            onExit();
          }}
          onExit={() => setConfirmation(false)}
          swapButton
          confirmButton={t("approve")}
        />
      )}
      <div
        onClick={() => {
          if (hasOpenModal) {
            closeOnClickOutside
              ? confirmModal
                ? setConfirmModal(null)
                : setModal("", {})
              : null;
          } else {
            isOrderEditing ? setConfirmation(true) : onExit();
          }
        }}
        className="fixed left-0 top-0 z-11 h-full w-full bg-text-secondary opacity-50"
      />
      <div
        style={{ top: headerHeight, height: `calc(100vh - ${headerHeight}px)` }}
        className={cn(
          "fixed right-0 w-full overflow-y-hidden bg-grey p-8 max-w-full md:max-w-[80%] transition-all duration-250",
          hasOpenModal ? "z-9" : "z-12",
          active ? "translateX(0)" : "translateX(100%) md:translateX(70%)"
        )}
      >
        <PosSystem />
      </div>
    </div>
  );
};

export default PosOrderSide;
